import { render, staticRenderFns } from "./outmat_send.vue?vue&type=template&id=4576ddc2&scoped=true&"
import script from "./outmat_send.vue?vue&type=script&lang=js&"
export * from "./outmat_send.vue?vue&type=script&lang=js&"
import style0 from "./outmat_send.vue?vue&type=style&index=0&id=4576ddc2&scoped=true&lang=less&"
import style1 from "./outmat_send.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4576ddc2",
  null
  
)

export default component.exports